"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var store_1 = require("../../../../app/store");
var AuthStore = __importStar(require("../../../../app/store/AuthStore"));
var constants_1 = require("../../../../youwell-common/constants");
var components_1 = require("../../../../common/components");
var constants_2 = require("../constants");
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var useStyles = (0, core_1.makeStyles)(function (theme) { return (0, core_1.createStyles)({
    root: {},
    table: {
        margin: theme.spacing(8, 0),
    },
    timePicker: {
        marginBottom: -38, // removes unused space for validation-message..
    },
    actions: {
        marginTop: theme.spacing(15),
        display: 'flex',
        justifyContent: 'flex-end',
    },
}); }, { name: 'EditBedtimePlan' });
var EditBedtimePlan = function (_a) {
    var bedtimePlan = _a.bedtimePlan, onClose = _a.onClose;
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var profileData = (0, store_1.useYouwellSelector)(function (state) { return state.auth.profileData; });
    var _b = React.useState({ bedTime: null, wakeTime: null }), planDetails = _b[0], setPlanDetails = _b[1];
    var _c = React.useState(false), hasChanged = _c[0], setHasChanged = _c[1];
    var handleChange = function (name) { return function (date) {
        setPlanDetails(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = date, _a)));
        });
        setHasChanged(true);
    }; };
    React.useEffect(function () {
        if (bedtimePlan) {
            setPlanDetails({
                bedTime: (0, dateUtils_1.getLocalDate)(bedtimePlan.bedTime, false),
                wakeTime: (0, dateUtils_1.getLocalDate)(bedtimePlan.wakeTime, false),
            });
        }
    }, [bedtimePlan]);
    var save = function () {
        var _a;
        var userData = __assign(__assign({}, profileData === null || profileData === void 0 ? void 0 : profileData.extendedProperties), (_a = {}, _a[constants_1.userDataProperties.bedtimePlan.bedTime] = (0, dateUtils_1.timeOnly)(planDetails.bedTime), _a[constants_1.userDataProperties.bedtimePlan.wakeTime] = (0, dateUtils_1.timeOnly)(planDetails.wakeTime), _a));
        dispatch(AuthStore.actionCreators.updateUserData(userData, { callback: onClose }));
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(core_1.Table, { className: classes.table },
            React.createElement(core_1.TableBody, null,
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, null, translate('sleepDiary.plannedBedTime')),
                    React.createElement(core_1.TableCell, { align: "right" },
                        React.createElement(components_1.TimePicker, { className: classes.timePicker, value: planDetails.bedTime, onChange: handleChange('bedTime'), defaultValue: constants_2.defaultSleepTime, disableUnderline: true, inputAdornmentBeforeInput: true }))),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, null, translate('sleepDiary.plannedWakeTime')),
                    React.createElement(core_1.TableCell, { align: "right" },
                        React.createElement(components_1.TimePicker, { className: classes.timePicker, value: planDetails.wakeTime, onChange: handleChange('wakeTime'), defaultValue: constants_2.defaultWakeTime, disableUnderline: true, inputAdornmentBeforeInput: true }))))),
        React.createElement("div", { className: classes.actions },
            React.createElement(core_1.Button, { onClick: save, disabled: !hasChanged }, translate('common.save')))));
};
EditBedtimePlan.defaultProps = {
    onClose: null,
};
exports.default = EditBedtimePlan;
